(async function () {
    const container = document.getElementById('app-container');
    const stage = document.getElementById('stage');
    // 获取视频元素，用于监听元数据加载
    const videoDesktop = document.getElementById('video-desktop');
    const videoMobile = document.getElementById('video-mobile');

    const config = {
        cardCount: 18,
        friction: 0.92,
        sensitivity: 0.02,
        radius: 0,
        baseOffset: 0,
        cardHeight: 0,
        gap: 5,
        squeeze: 0
    };

    const cards = [];

    async function init() {
        if (!window.urlsJsonPath) return; // fail-safe if not in Shopify env yet or somehow absent

        try {
            const response = await fetch(window.urlsJsonPath);
            const urlsData = await response.json();

            // Set dynamic video sources
            if (videoDesktop && urlsData['digital-art']['video-desktop']) {
                const sourceDesk = document.createElement('source');
                sourceDesk.src = urlsData['digital-art']['video-desktop'];
                sourceDesk.type = 'video/mp4';
                videoDesktop.appendChild(sourceDesk);
                videoDesktop.load();
            }
            if (videoMobile && urlsData['digital-art']['video-mobile']) {
                const sourceMob = document.createElement('source');
                sourceMob.src = urlsData['digital-art']['video-mobile'];
                sourceMob.type = 'video/mp4';
                videoMobile.appendChild(sourceMob);
                videoMobile.load();
            }

            const images = urlsData['digital-art'].images;
            config.cardCount = images.length;

            // 使用 DocumentFragment 优化 DOM 操作（小优化）
            const fragment = document.createDocumentFragment();

            for (let i = 0; i < config.cardCount; i++) {
                const card = document.createElement('div');
                card.className = 'card';
                const img = document.createElement('img');

                img.src = images[i];

                img.draggable = false;
                card.appendChild(img);
                fragment.appendChild(card); // 先加到片段里
                cards.push(card);
            }
            stage.appendChild(fragment); // 一次性上树

            // --- 核心修复：初始化时先尝试计算一次 ---
            updateDimensions();

            // --- 核心修复：使用 ResizeObserver 监听容器变形 ---
            // 只要视频加载撑开了容器，这里就会自动触发，重新计算半径
            const resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    updateDimensions();
                }
            });
            resizeObserver.observe(container);

            // --- 双重保险：视频元数据加载完成后强制刷新 ---
            if (videoDesktop) videoDesktop.addEventListener('loadedmetadata', updateDimensions);
            if (videoMobile) videoMobile.addEventListener('loadedmetadata', updateDimensions);
        } catch (e) {
            console.error("Failed to load urls.json for digital art section", e);
        }
    }

    function updateDimensions() {
        const w = window.innerWidth;
        // 修复：如果容器高度还没撑开（例如视频还没加载），给一个最小兜底值，防止计算出 0 半径
        const h = container.offsetHeight || window.innerHeight * 0.5;
        const stageH = stage.offsetHeight || window.innerHeight * 0.4;

        const isMobile = w <= 768;

        if (isMobile) {
            config.radius = w * 2;
            config.cardHeight = stageH * 0.75;
            config.baseOffset = stageH * 0.00;
            config.gap = 8;
            config.squeeze = 0.2;
            config.sensitivity = 0.1;
        } else {
            // 桌面端逻辑
            config.radius = h * 6.5;
            config.cardHeight = h * 0.4;
            config.baseOffset = h * 0.4;
            config.gap = 1.8;
            config.squeeze = 0.2;
            config.sensitivity = 0.02;
        }

        cards.forEach(card => {
            card.style.height = `${config.cardHeight}px`;
        });
    }

    // window resize 依然保留，作为全局变化的响应
    window.addEventListener('resize', updateDimensions);

    // --- 动画逻辑 (保持不变) ---
    let progress = 0;
    let target = 0;
    let isDragging = false;
    let startX = 0;
    let velocity = 0;
    let animationFrameId;

    function render() {
        if (!isDragging) {
            velocity *= config.friction;
            target += velocity;
        }
        progress += (target - progress) * 0.1;
        let currentVel = target - progress;

        cards.forEach((card, i) => {
            const totalCards = config.cardCount;
            const gap = config.gap;
            let angle = (i * gap) + progress;
            const totalAngle = totalCards * gap;

            while (angle < -totalAngle / 2) angle += totalAngle;
            while (angle > totalAngle / 2) angle -= totalAngle;

            const dynamicGap = gap + (Math.abs(currentVel) * config.squeeze);
            const finalAngle = (angle / gap) * dynamicGap;
            const theta = finalAngle * Math.PI / 180;

            const x = Math.sin(theta) * config.radius;
            const y = (config.radius - Math.cos(theta) * config.radius) + config.baseOffset;

            const rotate = finalAngle;
            const dist = Math.abs(finalAngle);

            // 简单的 z-index 逻辑，足够用了
            const zIndex = 1000 - Math.floor(Math.abs(finalAngle + 180) * 10);


            const brightness = 1 - (dist / (window.innerWidth <= 768 ? 150 : 200));

            card.style.zIndex = zIndex;
            card.style.transform = `
                translate3d(${x}px, ${y}px, 0) 
                translate(-50%, 0)
                rotateZ(${rotate}deg) 
            `;
            card.style.filter = `brightness(${Math.max(0.7, brightness)})`;
        });
        animationFrameId = requestAnimationFrame(render);
    }

    // --- 交互事件 (保持不变) ---
    const touchTarget = document.getElementById('app-container');

    touchTarget.addEventListener('mousedown', e => {
        isDragging = true;
        startX = e.clientX;
        velocity = 0;
        cards.forEach(c => c.style.cursor = 'grabbing');
        e.preventDefault();
    });

    window.addEventListener('mousemove', e => {
        if (!isDragging) return;
        e.preventDefault();
        const delta = (e.clientX - startX) * config.sensitivity;
        target += delta;
        startX = e.clientX;
    });

    window.addEventListener('mouseup', () => {
        isDragging = false;
        cards.forEach(c => c.style.cursor = 'grab');
    });

    stage.addEventListener('touchstart', e => {
        isDragging = true;
        startX = e.touches[0].clientX;
        velocity = 0;
    }, { passive: false });

    window.addEventListener('touchmove', e => {
        if (!isDragging) return;
        const currentX = e.touches[0].clientX;
        const diffX = Math.abs(currentX - startX);
        if (diffX > 5) {
            if (e.cancelable) e.preventDefault();
        }
        const delta = (e.touches[0].clientX - startX) * config.sensitivity;
        target += delta;
        startX = e.touches[0].clientX;
    }, { passive: false });

    // --- Scroll coupling logic ---
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        // 计算滚动差值
        const deltaY = currentScrollY - lastScrollY;

        // 只有当没有拖拽时，或者想要在拖拽时也叠加滚动速度，都可以。这里选择始终生效
        // 增量乘以一个灵敏度系数，然后加到目标角度上
        // 根据需要的旋转方向，这里可以是 + 或 - deltaY
        target += (deltaY * config.sensitivity * 0.3); // 放大一下灵敏度，因为滚动的 delta 可能较小

        lastScrollY = currentScrollY;
    }, { passive: true });

    window.addEventListener('touchend', () => {
        isDragging = false;
    });

    window.addEventListener('dragstart', (e) => e.preventDefault(), { passive: false });


    // 启动（异步等待初始化后再开始 render）
    await init();
    render();

})();